import { API_BASE_URL } from "@/config";
import { apiFetch } from "@/services/api-client/apiFetch";
import type { Avatar } from "@/types/avatar";

async function getAvatars(): Promise<Avatar[]> {
  const resp = await apiFetch(`${API_BASE_URL}/avatars`);
  if (!resp.ok) throw new Error("Failed to fetch avatars");
  return resp.json();
}

async function createAvatar(data: {
  name: string;
  image: string;
  images?: string[]; // additional reference photos
  archetype: string;
  voiceAudio?: string;
}): Promise<Avatar> {
  const resp = await apiFetch(`${API_BASE_URL}/avatars`, {
    method: "POST",
    body: JSON.stringify({
      name: data.name,
      image: data.image,
      images: data.images && data.images.length > 0 ? data.images : undefined,
      archetype: data.archetype,
      voiceAudio: data.voiceAudio,
    }),
  });
  if (!resp.ok) {
    throw new Error("Failed to create avatar");
  }
  return resp.json();
}

async function updateAvatar(
  avatarId: string,
  data: {
    name: string;
    archetype: string;
    voiceAudio?: string;
    regenerateImage?: boolean;
  },
): Promise<void> {
  const resp = await apiFetch(`${API_BASE_URL}/avatars/${avatarId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
  if (!resp.ok) throw new Error("Failed to update avatar");
}

async function deleteAvatar(avatarId: string): Promise<void> {
  const resp = await apiFetch(`${API_BASE_URL}/avatars/${avatarId}`, {
    method: "DELETE",
  });
  if (!resp.ok) throw new Error("Failed to delete avatar");
}

export const apiAvatar = {
  getAvatars,
  createAvatar,
  updateAvatar,
  deleteAvatar,
};
